export class RequestError extends Error {
  status: number;
  code?: number;
  constructor(message: string, status: number, code?: number) {
    super(message);
    this.name = "RequestError";
    this.status = status;
    this.code = code;
  }
}
